import { isToday, isThisISOWeek, isFriday, isSaturday, isSunday } from "date-fns";

/**
 * Bucket a date range for analytics.
 * Returns: "today" | "weekend" | "upcoming"
 */
export function formatDateBucket(startDate: string, _endDate?: string | null): string {
  const d = new Date(startDate);
  if (isToday(d)) return "today";
  const day = d.getDay();
  const isWeekend = isFriday(d) || isSaturday(d) || isSunday(d);
  if (isWeekend && isThisISOWeek(d)) return "weekend";
  return "upcoming";
}

/**
 * Bucket distance in km for analytics.
 * Returns: "0-5" | "5-15" | "15-50" | "50+" | "unknown"
 */
export function distanceKmBucket(distanceKm: number | null): string {
  if (distanceKm == null) return "unknown";
  if (distanceKm < 5) return "0-5";
  if (distanceKm < 15) return "5-15";
  if (distanceKm < 50) return "15-50";
  return "50+";
}
